/**
 * CMDB service criticality tiers (migration 031). Tier 0 = mission-critical
 * through Tier 3 = standard; null = unclassified. Single source of truth for
 * the labels, short badges and badge colours used across the Services UI.
 */
export interface TierMeta {
  tier: number;
  /** Short badge text, e.g. "T0". */
  short: string;
  /** Full label, e.g. "Tier 0 · Mission-critical". */
  label: string;
  /** Tailwind classes for the badge (brand palette). */
  badgeClass: string;
}

export const SERVICE_TIERS: readonly TierMeta[] = [
  { tier: 0, short: 'T0', label: 'Tier 0 · Mission-critical', badgeClass: 'bg-red/15 text-red' },
  { tier: 1, short: 'T1', label: 'Tier 1 · Critical', badgeClass: 'bg-orange/15 text-orange' },
  { tier: 2, short: 'T2', label: 'Tier 2 · Important', badgeClass: 'bg-lightBlue/20 text-navy' },
  { tier: 3, short: 'T3', label: 'Tier 3 · Standard', badgeClass: 'bg-darkGrey/10 text-darkGrey' },
] as const;

/** Metadata for a tier value, or null when unclassified / out of range. */
export function tierMeta(tier: number | null | undefined): TierMeta | null {
  if (tier == null) return null;
  return SERVICE_TIERS.find((t) => t.tier === tier) ?? null;
}
